/**
 * The root .gitignore `ss init` writes. Kept out of init.ts so a test can hold
 * it to its promises — above all that no secret file of the generated project
 * (appsettings.Local.json, docker-images/.env, a DataProtection PFX) can be
 * committed by accident.
 */
export const ROOT_GITIGNORE = `## .NET
bin/
obj/
*.user
*.suo
.vs/

## EF Core design-time artifacts (Roslyn BuildHost creates corrupted bin folders on Windows)
**/bin?Debug/
**/bin[!a-zA-Z0-9/\\\\]Debug/

## Node
node_modules/
dist/

## IDE
.idea/

## Environment
*.env
*.env.local
*.env.standalone
appsettings.Local.json
appsettings.*.Local.json

## Secrets — certificates (DataProtection key ring), and docker-images/.env (covered by *.env)
*.pfx

## Build
*.log

## Database
*.db
*.db-shm
*.db-wal

## SmartStack BA — per-module re-run baseline (ba-develop compute-page-diff)
.run-snapshot.json

## SmartStack upgrade — undo log of ss upgrade (may hold secrets; restore with ss upgrade --restore)
.smartstack/upgrade-backups/

## SmartStack dev-only credentials — test-users manifest (scaffold-seed / scaffold-core-seed,
## plaintext dev password, regenerated on every run; consumed by run-ui-test)
tests/ui-test/test-users.json
`;
